<div *ngIf="content.referralNotice && referralCode" class="referral-toast toast__item">
  <div class="toast__content">
    <p [internalInnerHtml]="content.referralNotice" [userEventSource]="userEventSource"></p>
  </div>
</div>
<div #stepHeader class="step-header" *ngIf="currentStepText">
  <h1>{{ currentStepText.title }}</h1>
  <div [internalInnerHtml]="currentStepText.body" [userEventSource]="userEventSource"></div>
</div>
<air-form
  #formComponent
  (submitted)="submitValues($event)"
  [controls]="form"
  [showMandatory]="true"
  [showValidFields]="true"
  [showInvalidToast]="true"
  [alternateReCaptchaActions]="[reCaptchaAction.createUser, reCaptchaAction.createCampaignUser]"
  [userEventSource]="userEventSource"
>
  <a
    class="button form__button button--full-width button--cta"
    [airButtonLoading]="isSubmitting"
    [class.button--disabled]="formDisabled"
    (click)="currentStepIndex + 1 !== this.content.steps?.length ? nextStep() : submit($event)"
  >
    <span>{{ buttonText }}</span>
  </a>
</air-form>
<div *ngIf="isLoading" class="loading">
  <div class="form">
    <div class="form-section grid">
      <h2 class="col-12 col-6--md col-4--sm">{{ "general.label.loading" | translate }}</h2>
      <div class="col-6 col-3--sm col-4--sm">
        <div class="form-group">
          <label>{{ "general.label.loading" | translate }}</label>
          <input class="form-control" type="text" />
        </div>
      </div>
      <div class="col-6 col-3--sm col-4--sm">
        <div class="form-group">
          <label>{{ "general.label.loading" | translate }}</label>
          <input class="form-control" type="text" />
        </div>
      </div>
      <div class="form-group col-12 col-6--md col-4--sm">
        <label>{{ "general.label.loading" | translate }}</label>
        <input class="form-control" type="text" />
      </div>
      <div class="form-group col-12 col-6--md col-4--sm">
        <label>{{ "general.label.loading" | translate }}</label>
        <input class="form-control" type="text" />
      </div>
      <div class="form-group col-12 col-6--md col-4--sm">
        <label>{{ "general.label.loading" | translate }}</label>
        <input class="form-control" type="text" />
      </div>
      <div class="form-group col-12 col-6--md col-4--sm">
        <label>{{ "general.label.loading" | translate }}</label>
        <input class="form-control" type="text" />
      </div>
      <div class="form-group col-12 col-6--md col-4--sm">
        <label>{{ "general.label.loading" | translate }}</label>
        <input class="form-control" type="text" />
      </div>
      <div class="form-group col-12 col-6--md col-4--sm">
        <label>{{ "general.label.loading" | translate }}</label>
        <input class="form-control" type="text" />
      </div>
      <div class="form-group col-12 col-6--md col-4--sm">
        <label>{{ "general.label.loading" | translate }}</label>
        <input class="form-control" type="text" />
      </div>
      <div class="form-group col-12 col-6--md col-4--sm">
        <label>{{ "general.label.loading" | translate }}</label>
        <input class="form-control" type="text" />
      </div>
    </div>
  </div>
</div>
<p class="form__mandatory-label">{{ "general.label.mandatory_fields" | translate }}</p>
